import { RewardTiers } from "../editor/inputs/programs/ProgramRewardsInput";

const PayoutRangeDisplay = ({
  payoutRange,
  className
}: {
  payoutRange: RewardTiers;
  className?: string;
}) => (
  <p className={"rounded-lg text-ctb-green-200 " + className}>
    ${payoutRange.low} - {payoutRange.critical}
  </p>
);

export default PayoutRangeDisplay;
